






























import { Component, Prop, Mixins, Watch } from "vue-property-decorator";

// Components
import ClientBillingBasicConfigurationForm from "@/components/app/global/client/clientBillingBasicConfigurationForm.vue";

// Mixins
import Context from "@/mixins/context";

// Types
import { IClient } from "@/models/clients";

@Component({
  components: {
    "client-billing-basic-configuration-form": ClientBillingBasicConfigurationForm
  }
})
export default class ClientBillingBasicConfigurationComp extends Mixins(
  Context
) {
  // Refs

  public declare $refs: {
    billingBasicForm: ClientBillingBasicConfigurationForm;
  };

  // Props

  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise", "div"].includes(tag)
  })
  public readonly tag!: string;

  @Prop({ required: true })
  public client!: IClient;

  @Prop({ default: false })
  public isSticky!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public isEnabled = false;
  public isProcessing = false;

  // Methods

  public async validateBeforeSubmit() {
    return this.$refs.billingBasicForm.validateBeforeSubmit();
  }

  public async revertToInitialState() {
    this.$refs.billingBasicForm.revertToInitialState();
  }

  // Watchers

  @Watch("isEnabled")
  public onIsEnabledChange() {
    this.$emit("isEnabled", this.isEnabled);
  }

  @Watch("isProcessing")
  public onIsProcessingChange() {
    this.$emit("isProcessing", this.isProcessing);
  }
}
